import { SUBSCRIPTIONDETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  payments: [],
  subscriptionData: [],
  subscriptionDetailsStatus: undefined,
  subscriptionDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTIONDETAILS.FETCH:
      return {
        ...state,
        subscriptionDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case SUBSCRIPTIONDETAILS.SUCCESS:
      return {
        ...state,
        subscriptionData: action.payload,
        subscriptionDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case SUBSCRIPTIONDETAILS.FAILED:
      return {
        ...state,
        subscriptionDetailsError: action.payload,
        subscriptionDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    case SUBSCRIPTIONDETAILS.PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: action.payload,
      };
    default:
      return state;
  }
};
